import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPlaylistSubmissionData, PlaylistEditor, usePlaylistForm, useSubmitPlaylistEditor } from 'screens/PlaylistEditorModal';
import UnsavedChangesBlockerModal from 'screens/UnsavedChangesBlockerModal';
import { EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EditPlaylistDetailsPage(_ref) {
  var initialPlaylistDetails = _ref.initialPlaylistDetails,
    _ref$inContentManager = _ref.inContentManagerContext,
    inContentManagerContext = _ref$inContentManager === void 0 ? false : _ref$inContentManager,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var playlistForm = usePlaylistForm({
    playlist: initialPlaylistDetails
  });
  var _useSubmitPlaylistEdi = useSubmitPlaylistEditor({
      playlistId: initialPlaylistDetails.id,
      badge: initialPlaylistDetails.badge,
      ownerTeamId: initialPlaylistDetails.ownerTeamId
    }),
    submitPlaylistEditor = _useSubmitPlaylistEdi.submitPlaylistEditor,
    isSubmissionLoading = _useSubmitPlaylistEdi.isSubmissionLoading;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    var cleanedPlaylistData = formatPlaylistSubmissionData({
      playlistForm: playlistForm,
      isEditMode: true
    });
    if (onSubmit) {
      onSubmit(cleanedPlaylistData);
    } else {
      submitPlaylistEditor(cleanedPlaylistData);
    }
  };
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit,
    children: [!inContentManagerContext && /*#__PURE__*/_jsx(UnsavedChangesBlockerModal, {
      hasUnsavedChanges: playlistForm.wasChanged && !isSubmissionLoading
    }), /*#__PURE__*/_jsx(PlaylistEditor, {
      playlistForm: playlistForm,
      playlist: initialPlaylistDetails
    }), /*#__PURE__*/_jsx(EditorPageStickySaveDiscardButton, {
      cardVariant: "raised",
      hasChanges: playlistForm.wasChanged,
      isDisabled: playlistForm.hasErrors,
      isSaving: isSubmissionLoading,
      onDiscard: function onDiscard() {
        return playlistForm.reset();
      },
      buttonText: t(inContentManagerContext ? 'actions_done' : 'actions_save_changes')
    })]
  });
}